import { defineStore } from "pinia";
import piniaPersistConfig from "@/config/piniaPersist";
import { login, logout } from "@/api/modules/auth";
import { getAccount, getMember, register } from "@/api/modules/members";

import type { AuthState } from "./typing";

export const useAuthStore = defineStore({
	id: "auth",
	state: (): AuthState => ({
		token: "" as AuthState["token"],
		member: {} as AuthState["member"],
		account: {} as AuthState["account"],
		showDialog: true as AuthState["showDialog"],
		xTicket: ""
	}),
	getters: {
		tokenGet: state => state.token,
		memberGet: state => state.member,
		accountGet: state => state.account,
		showDialogGet: state => state.showDialog,
		xTicketGet: state => state.xTicket
	},
	actions: {
		setShowDialog(value: AuthState["showDialog"]) {
			this.showDialog = value;
		},

		async register(params: API.RegisterCmd) {
			const response = await register(params);
			return response;
		},

		async login(params: API.LoginCmd) {
			try {
				const response = await login(params);
				this.setToken(response.data?.row?.token ?? "");
				this.setAccount();
				this.setMember();
				this.setShowDialog(true);
				return response;
			} catch (e) {
				return Promise.reject(e);
			}
		},

		async onChatLogin(params: API.Member) {
			try {
				window.ssq.push("setLoginInfo", {
					user_id: params.phone, // 加密后的用户 id, 必填  对应用户的channel_uid
					user_name: params.username, // 对应用户名
					phone: params.phone // 对应用户手机号
				});
			} catch (error) {
				console.log("error :>> ", error);
			}
		},
		async setMember() {
			const { data } = await getMember();
			this.member = data?.row ?? {};
			this.onChatLogin(this.member);
		},

		async setAccount() {
			const { data } = await getAccount();
			this.account = data?.row ?? {};
		},

		setToken(token: string) {
			this.token = token;
		},
		setXTicket(xTicket: string) {
			this.xTicket = xTicket;
		},
		async logout() {
			try {
				await logout();
			} catch (error) {}
			this.token = "";
			this.member = {} as API.Member;
			this.account = {} as API.Account;
		}
	},
	persist: piniaPersistConfig("auth", ["token", "member", "account", "showDialog", "xTicket"])
});
